/* eslint-disable no-console */
import printJS from 'print-js';
import { PDF_FILE_PREFIX } from '../constants';

export const downloadPdf = (resumePdf: string | null, outputFileName = 'file.pdf') => {
  if (!resumePdf) return;

  try {
    // Method 1: Try the binary conversion approach first
    try {
      // Create a binary blob from the base64 data
      const binaryString = atob(resumePdf);
      const bytes = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i += 1) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create a blob and URL for download
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');

      link.href = url;
      link.download = outputFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      // Method 2: Fall back to data URI approach if binary conversion fails
      console.log('Falling back to data URI download method');
      const dataUri = resumePdf.startsWith(PDF_FILE_PREFIX) ? resumePdf : `${PDF_FILE_PREFIX}${resumePdf}`;

      const link = document.createElement('a');

      link.href = dataUri;
      link.download = outputFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error('Error downloading PDF:', error);
  }
};

export const printPDF = (pdfBase64: string | null) => {
  if (!pdfBase64) return;

  try {
    const base64Data = pdfBase64.replace(PDF_FILE_PREFIX, '');

    printJS({ printable: base64Data, type: 'pdf', base64: true });
  } catch (error) {
    console.error('Error printing PDF:', error);
  }
};
